import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { cn } from "@/libs/utils";
import { WEBVIEW_ROUTES } from "@/components/webview/route";
import GlobalLoadingWebView from "@/components/webview/shared/GlobalLoadingWebView";

// loading 안보여줄 router path
const excludeRoutesPaths = [
  WEBVIEW_ROUTES.webviewSearchPreview,
  WEBVIEW_ROUTES.webviewAthSearchPreview,
];
const isShowLoadingRouter = (url: string) =>
  !excludeRoutesPaths.some((route) => url.startsWith(route));

export const GlobalRouterLoadingWebView = () => {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const handleStart = (url: string) => {
      if (!isShowLoadingRouter(url)) return;

      setIsLoading(true);
    };
    const handleComplete = () => {
      setIsLoading(false);
    };

    router.events.on("routeChangeStart", handleStart);
    router.events.on("routeChangeComplete", handleComplete);
    router.events.on("routeChangeError", handleComplete);

    return () => {
      router.events.off("routeChangeStart", handleStart);
      router.events.off("routeChangeComplete", handleComplete);
      router.events.off("routeChangeError", handleComplete);
    };
  }, [router]);

  return (
    <div
      className={cn(
        "pointer-events-none fixed inset-0 z-[9999] transition-opacity duration-300",
        isLoading ? "opacity-100" : "opacity-0",
      )}
    >
      {/* 딤 + 스피너 */}
      <GlobalLoadingWebView />
    </div>
  );
};
